import { HTTPClientInterface } from "./HTTPClientInterface";
import { Logger } from "@shared/utils/Logger";
import { Analytics } from "./Analytics/Analytics";

export class CoreDependencies {
    private _httpClient: HTTPClientInterface;
    private _unauthenticatedHTTPClient: HTTPClientInterface;
    readonly analytics: Analytics

    constructor(
        httpClient: HTTPClientInterface,
        unauthenticatedHTTPClient: HTTPClientInterface,
        analyticsSource?: string,
    ) {
        this._httpClient = httpClient;
        this.analytics = new Analytics(httpClient)
        if (analyticsSource) {
            this.analytics.setSource(analyticsSource)
        }
        this._unauthenticatedHTTPClient = unauthenticatedHTTPClient
        // this._httpClient.verbose = true
        // this._unauthenticatedHTTPClient.verbose = true
    }

    public get httpClient(): HTTPClientInterface {
        return this._httpClient
    }

    public get unauthenticatedHTTPClient(): HTTPClientInterface {
        return this._unauthenticatedHTTPClient
    }

    public setOrganizationID(organizationID: string) {
        this.analytics.setSelectedOrganizationID(organizationID)
    }

    public setAnalyticsSource(source: string) {
        this.analytics.setSource(source)
    }

    public setAPIToken(token: string) {
        Logger.logObject("http client headers ID", (this._httpClient as any)?.instanceID)
        const existingHeaders = ((this._httpClient as any)?.clientHeaders ?? {}) as Record<string, string>
        this._httpClient.setClientHeaders({
            ...existingHeaders,
            "Content-Type": "application/json",
            "x-access-token": token
        })
    }
}
